class HeaderNav {
  constructor() {
    this.header = document.querySelector('[data-header]');
    if (!this.header) return;
    this.initMegaMenus();
    this.initSearchModal();
    this.initMobileNav();
  }

  initMegaMenus() {
    const triggers = this.header.querySelectorAll('[data-mega-menu-trigger]');
    triggers.forEach((trigger) => {
      const item = trigger.closest('[data-mega-menu-item]');
      const panel = item.querySelector('[data-mega-menu]');
      if (!panel) return;

      const open = () => {
        trigger.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
      };
      const close = () => {
        trigger.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
      };

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      trigger.addEventListener('focus', open);
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          trigger.focus();
        }
      });
      trigger.addEventListener('click', (event) => {
        if (window.matchMedia('(hover: none)').matches) {
          event.preventDefault();
          const isOpen = panel.classList.contains('is-open');
          this.header.querySelectorAll('[data-mega-menu].is-open').forEach((p) => p.classList.remove('is-open'));
          if (!isOpen) open();
          else close();
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!this.header.contains(event.target)) {
        this.header.querySelectorAll('[data-mega-menu].is-open').forEach((p) => p.classList.remove('is-open'));
      }
    });
  }

  initSearchModal() {
    const modal = document.getElementById('SearchModal');
    const trigger = document.querySelector('[data-search-trigger]');
    if (!modal || !trigger) return;
    const input = modal.querySelector('[data-search-input]');
    const closeButtons = modal.querySelectorAll('[data-search-close]');

    const open = () => {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      window.requestAnimationFrame(() => input.focus());
    };
    const close = () => {
      modal.hidden = true;
      document.body.style.overflow = '';
      trigger.focus();
    };

    trigger.addEventListener('click', open);
    closeButtons.forEach((btn) => btn.addEventListener('click', close));
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  }

  initMobileNav() {
    const nav = document.getElementById('MobileNav');
    const trigger = document.querySelector('[data-mobile-nav-trigger]');
    if (!nav || !trigger) return;
    const closeButtons = nav.querySelectorAll('[data-mobile-nav-close]');

    const open = () => {
      nav.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      nav.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      nav.querySelectorAll('[data-mobile-submenu].is-open').forEach((p) => p.classList.remove('is-open'));
    };

    trigger.addEventListener('click', open);
    closeButtons.forEach((btn) => btn.addEventListener('click', close));
    nav.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });

    nav.querySelectorAll('[data-mobile-submenu-trigger]').forEach((submenuTrigger) => {
      const submenu = document.getElementById(submenuTrigger.getAttribute('aria-controls'));
      submenuTrigger.addEventListener('click', () => {
        submenu.classList.add('is-open');
        submenuTrigger.setAttribute('aria-expanded', 'true');
      });
    });

    nav.querySelectorAll('[data-mobile-submenu-back]').forEach((backButton) => {
      backButton.addEventListener('click', () => {
        backButton.closest('[data-mobile-submenu]').classList.remove('is-open');
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new HeaderNav());
